import { BaseModel } from './base';

export enum ReservationCancellationTypeDisplayMode {
  both = 0,
  internal = 1,
  customer = 2,
}

export const ReservationCancellationTypeDisplayModeLabels: Record<ReservationCancellationTypeDisplayMode, string> = {
  [ReservationCancellationTypeDisplayMode.both]: 'api.models.reservationCancellationType.both',
  [ReservationCancellationTypeDisplayMode.internal]: 'api.models.reservationCancellationType.internal',
  [ReservationCancellationTypeDisplayMode.customer]: 'general.customer',
};

export class ReservationCancellationType extends BaseModel {
  idReservationCancellationType!: number;
  name!: string;
  displayMode!: ReservationCancellationTypeDisplayMode;

  override objectID(): string | null {
    return this.idReservationCancellationType?.toString() ?? null;
  }
}
